import axios from 'axios'
import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'
import {
  Auction,
  AuthorizeValues,
  AddDocument,
  Solvency,
  Valid,
  AuctionBase,
} from '../models/Auction'

interface AuctionListResponse extends HttpResponse {
  data: Auction[]
}

interface AuctionResponse extends HttpResponse {
  data: Auction
}

const Auctions = {
  list: () => requests.get<AuctionListResponse>('/Auction'),
  details: (id: string) => requests.get<AuctionResponse>(`/Auction/${id}`),
  create: (auction: AuctionBase) => requests.post<AuctionResponse>('/Auction', auction), // TODO: check if correct type
  edit: (auction: Auction) =>
    requests.put<AuctionResponse>(`/Auction/${auction.id}`, auction),
  del: (id: string) => requests.del<HttpResponse>(`/Auction/${id}`),
  authorize: (authorization: AuthorizeValues) =>
    requests.post<HttpResponse>('/Auction/authorize', authorization),
  addDocument: (doc: AddDocument) => {
    const formData = new FormData()
    formData.append('File', doc.file)
    formData.append('auctionId', doc.auctionId)
    return axios.post<Solvency>('/Auction/document', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  deleteDocument: (id: string) => requests.del<HttpResponse>(`/Auction/solvencyAttachment/${id}`),
  setValid: (valid: Valid) => requests.put<HttpResponse>(`/Auction/setValid/${valid.id}`, valid),
}

export default Auctions
